<template>
  <el-dialog
    class="dialogStyle"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="$t('messageBox.messageDetails')"
    :before-close="close"
    :append-to-body="false"
    custom-class="message-dialog"
  >
    <div class="contentClass">
      <div class="titleClass">
        <span>
          <span style='font-size:14px;font-weight:600'>{{ $t("messageBox.messageTitle") + " : "}}</span><span>{{messageContent.title }}</span>
        </span>
        <span style="margin-top: 10px;font-size:14px;font-weight:600">{{
          $t("messageBox.content") + " : "
        }}</span>
      </div>
      <div class="bodyClass" v-html="messageContent.body"></div>
      <el-divider v-if="messageOtherInfo.attaches && messageOtherInfo.attaches.length"></el-divider>
      <div class="attachClass" v-if="messageOtherInfo.attaches && messageOtherInfo.attaches.length">
        <div class="downloadAll">
          <span>{{ $t("messageBox.appendFile") + " : " }}</span>
          <el-button type="text" @click="downloadAll">{{
            $t("messageBox.downloadAll")
          }}</el-button>
        </div>
        <div class="attachItem" v-for="item in messageOtherInfo.attaches" :key="item.id">
          <span>{{ item.attachName }}</span>
          <i
            class="el-icon-download"
            style="color: #015ac5"
            @click="downloadAttachFile(item.attachId)"
          ></i>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="createUser" style='margin-top:-15px'>
        {{ $t("messageBox.createUser")}}:<span v-if='messageOtherInfo.createUser'>{{messageOtherInfo.createUser }}</span>
      </div>
      <div class="createTime">
        {{
          `${$t("messageBox.createTime")}: ${dataToString(
            messageOtherInfo.createTime
          )}`
        }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { initState as globalState } from "@/store/shardActions";
import to from "await-to-js";
import {dataToString} from "@/utils/utils.js";
export default {
  props: ["value"],
  watch: {
    value(v) {
      this.dialogVisible = v;
    },
  },
  components: {},

  computed: {
    language() {
      return globalState.currentLanguage;
    },
    messageContent() {
      let contentAll =
        this.$store.state.config.inboxDetailDialog.content?.content || {};
      return contentAll[this.language] || contentAll["en"] || {};
    },

    messageOtherInfo() {
      return this.$store.state.config.inboxDetailDialog.content;
    },
  },

  data() {
    return {
      dialogVisible: this.value,
      dataToString
    };
  },

  methods: {
    close() {
      this.$store.commit("config/changeInboxDetailDialog", {
        show: false,
        id: "",
        content: "",
      });
      this.$emit("input", false);
    },
    async downloadAll() {
      let attachIds = this.messageOtherInfo.attaches
        .map((item) => {
          return item.attachId;
        })
        .join();

      const [err, res] = await to(
        this.$httpList.getAttach(this.messageOtherInfo.id, { attachIds })
      );
      if (err) {
        return;
      }
    },
    async downloadAttachFile(attachId) {
      const [err, res] = await to(
        this.$httpList.getAttach(this.messageOtherInfo.id, {
          attachIds: attachId,
        })
      );
      if (err) {
        return;
      }
    },
  },
};
</script>
<style lang="scss">
.message-dialog {
  display: flex;
  flex-direction: column;
  .el-dialog__header{
    border-bottom: 1px solid rgb(233, 233, 233);
  }
  .el-dialog__body {
    padding: 30px 20px;
    color: rgb(88, 91, 97);
    font-size: 14px;
    word-break: break-all;
  }
  .message-content {
    .title {
      margin: 0;
    }
    .message-detail {
      p {
        margin: 0;
      }
    }
    .file-list {
      padding: 0;
      margin: 0;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        cursor: pointer;

        &:hover {
          background-color: $grayBg;
        }

        .file-name {
          margin: 0;
          flex-grow: 1;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          word-break: break-all;
        }
        .el-button {
          margin-left: 10px;
          flex-shrink: 0;
        }
      }
    }
  }
  .contentClass {
    display: flex;
    flex-direction: column;
    color:#585B61;
    font-size:12px;
    font-weight:400;
    .titleClass {
      display: flex;
      flex-direction: column;
    }
    .bodyClass {
      max-height: 60vh;
      overflow: auto;
    }
    .attachClass {
      display: flex;
      flex-direction: column;
      margin-top:-30px;
      .downloadAll {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 10px 0px;
        align-items: center;
      }
      .attachItem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 2px 5px;
        cursor: pointer;
      }
      .attachItem:hover {
        background-color: #ecf5ff;
      }
    }
  }
}
</style>
